import { Grid, NumberInput } from "@mantine/core";
import { useEffect, useRef } from "react";

import { DisabledTextarea } from "../../../../../components/input/DisabledTextInput/DisabledTextarea";
import { PriceInput } from "../../../../../components/input/number/PriceInput";
import type { ArticleDto } from "../../../../../generated/client/octalog-service";
import type { OrderForm } from "../hooks/useOrderForm";
import { buildArticleItemKey } from "../utils/formKeyBuilder";

interface OrderItemArticleDetailsProps {
  form: OrderForm;
  index: number;
  article: ArticleDto | undefined;
}

export function OrderItemArticleDetails({ form, index, article }: OrderItemArticleDetailsProps) {
  const previousArticle = useRef(article);
  useEffect(() => {
    if (article !== previousArticle.current) {
      previousArticle.current = article;
      form.setFieldValue(buildArticleItemKey(index, "priceOverride"), undefined);
    }
  }, [article, form, index]);

  return (
    <Grid align="end" ta="left">
      <Grid.Col span={12}>
        <DisabledTextarea
          label="Name"
          {...form.getInputProps(buildArticleItemKey(index, "name"))}
          value={article?.name}
        />
      </Grid.Col>
      <Grid.Col span={12} ta="left">
        <DisabledTextarea
          label="Beschreibung"
          {...form.getInputProps(buildArticleItemKey(index, "description"))}
          value={article?.description}
        />
      </Grid.Col>
      <Grid.Col span={12} ta="left">
        <DisabledTextarea label="SKU" {...form.getInputProps(buildArticleItemKey(index, "sku"))} value={article?.sku} />
      </Grid.Col>
      <Grid.Col span={12}>
        <NumberInput
          data-testid="order-item-article-quantity"
          label="Anzahl"
          min={1}
          placeholder="Menge"
          {...form.getInputProps(buildArticleItemKey(index, "quantity"))}
        />
      </Grid.Col>
      <Grid.Col span={7}>
        <PriceInput
          data-testid="order-item-article-price"
          description={article?.price == undefined ? "Kein Preis in den Einstellungen definiert" : undefined}
          disabled={article == undefined || article?.price != undefined}
          externalValue={article?.price ?? undefined}
          label="Preis pro Stück"
          {...form.getInputProps(buildArticleItemKey(index, "price"))}
        />
      </Grid.Col>
      <Grid.Col span={5}>
        <PriceInput
          data-testid="order-item-article-price-override"
          description="Preis pro Stück überschreiben"
          disabled={article == undefined || article?.price == undefined}
          label="Angebot"
          {...form.getInputProps(buildArticleItemKey(index, "priceOverride"))}
        />
      </Grid.Col>
    </Grid>
  );
}
